import React from "react"
import DefaultLayout from "../layouts/DefaultLayout"
import DefaultHelmet from "../seo/DefaultHelmet"
import ShopifyThemesHeader from "../sections/ShopifyThemes/ShopifyThemesHeader"
import ShopifyThemesTextSection from "../sections/ShopifyThemes/ShopifyThemesTextSection"
import {
  shopifyThemesBenefitsContent,
  shopifyThemesHeaderContent,
  shopifyThemesImageWithTextContent,
  shopifyThemesMetaContent,
  shopifyThemesQuizContent,
  shopifyThemesReviewsContent,
  shopifyThemesSliderContent,
  shopifyThemesTextSectionContent,
} from "../sections/ShopifyThemes/shopify-themes-content"
import ShopifyThemesBenefits from "../sections/ShopifyThemes/ShopifyThemesBenefits"
import ShopifyThemesReviews from "../sections/ShopifyThemes/ShopifyThemesReviews"
import ShopifyThemesImageWithText from "../sections/ShopifyThemes/ShopifyThemesImageWithText"
import ShopifyThemesQuiz from "../sections/ShopifyThemes/ShopifyThemesQuiz"
import ShopifyThemesSlider from "../sections/ShopifyThemes/ShopifyThemesSlider"
import beaconWidgetIds from "../settings/beacon-widget-ids"
import useBeaconWidget from "../hooks/useBeaconWidget"
import useSchemaSettings from "../seo/schema/useSchemaSettings"
import { buildShopifyThemesCollectionSchema } from "../seo/schema"

const ShopifyThemes = ({ pageContext }) => {
  const metaData = pageContext?.page?.acfShopifyThemes?.metaData
  const pageTitle = metaData?.title || shopifyThemesMetaContent.title
  const pageDescription = metaData?.description || shopifyThemesMetaContent.description
  const helmetMeta = (shopifyThemesMetaContent.meta || []).map(item => {
    if (item.name === "title" || item.name === "twitter:title") {
      return { ...item, content: pageTitle }
    }

    if (item.name === "twitter:description") {
      return { ...item, content: pageDescription }
    }

    return item
  })
  const helmetContent = {
    ...shopifyThemesMetaContent,
    title: pageTitle,
    description: pageDescription,
    meta: helmetMeta,
  }
  const schemaContext = useSchemaSettings()
  const structuredData = buildShopifyThemesCollectionSchema({
    schemaContext,
    themes: pageContext?.themes || [],
    title: pageTitle,
    description: pageDescription,
  })

  useBeaconWidget(beaconWidgetIds.THEME)

  return (
    <DefaultLayout className="shopify-themes-page" isHeaderWithBlackText={true}>
      <DefaultHelmet {...helmetContent} structuredData={structuredData} />

      <ShopifyThemesHeader {...shopifyThemesHeaderContent} />

      <ShopifyThemesSlider {...shopifyThemesSliderContent} />

      <ShopifyThemesTextSection {...shopifyThemesTextSectionContent} />

      <ShopifyThemesBenefits {...shopifyThemesBenefitsContent} />

      <ShopifyThemesReviews {...shopifyThemesReviewsContent} />

      {shopifyThemesImageWithTextContent.map(section => (
        <ShopifyThemesImageWithText key={section.title} {...section} />
      ))}

      <ShopifyThemesQuiz {...shopifyThemesQuizContent} />
    </DefaultLayout>
  )
}

export default ShopifyThemes
